import React, { useState, Fragment, useEffect } from "react";
import {
  Container,
  Card,
  CardTitle,
  Button,
  CardFooter,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Form,
  Alert,
} from "reactstrap";
import { UserIcon, AddButton, Remove } from "../functions/Icons";
import CustomModalSearch from "../functions/CustomModalSearch";
import { useDispatch, useSelector } from "react-redux";
import {
  INVOICE_LINE_ITEM_VALUES,
  INVOICE_ADD_LINE_ITEM,
  INVOICE_DELETE_LINE_ITEM,
  INVOICE_UPDATE_FORM_BASE_VALUES,
  SAVE_INVOICE_FORM_REDUCER,
  RESET_INVOICE_FORM_REDUCER,
} from "../../../redux/actions/ActionTypes";
import { authHeader } from "../../../utils/functions/CoreFunctions";
import {
  getCurrentUserId,
  getCurrentAgencyId,
  getAlertToast,
  amountFormat,
  getConfirm,
} from "../../../utils/functions/CustomFunctions";
import API from "../../../redux/actions/API";
import Swal from "sweetalert2";
import {
  CREATE_INVOICE_URL,
  SAVE_INVOICE_URl,
  SELECT_INVOICE_URL,
  UPDATE_INVOICE_URL,
  CREATE_SUBSCRIPTION_URL,
  UPDATE_SUBSCRIPTION_URL,
  SELECT_SUBSCRIPTION_URL,
  REMOVE_COUPON_URL,
  AGENCY_DETAILS_URL,
} from "../../../utils/APIEndpoints";
import { AGENCY_INVOICE_PAGE } from "../../../utils/AppRoutes";
import { useHistory, useParams } from "react-router-dom";
import CustomLoader from "../../common/CustomLoader";
import SubscriptionModal from "../functions/SubscriptionModal";
import ApplyCouponModal from "./ApplyCouponModal";
import InvoicePreview from "../functions/InvoicePreview";
import {
  getCouponDetails,
  getLocationCodeList,
} from "../../../redux/actions/index";
import moment from "moment";
import Loader from "../../loader";
import DatePicker from "react-datepicker";
import CustomPageLoading from "../../../utils/functions/CustomPageLoading";

export default function NewInvoice(props) {
  const {
    location: { pathname = "" },
  } = props;
  const urlPaths = pathname.split("/");

  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [initialLoader, setIntialLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  //Modals
  const [modal, setModal] = useState(false);
  const [couponModal, setCouponModal] = useState(false);
  const [customerModalFlag, setCustomerModalFlag] = useState(false);
  const [selectedCustomer, setCustomerSelected] = useState(null);
  const [subscriptionModal, setSubscriptionModal] = useState(false);
  const [coupon, setCoupons] = useState(null);
  const [showTaxInput, setShowTaxInput] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState(null);

  let [subscriptionInitialValues, setSubscriptionInitialValues] = useState({
    invoiceSendInterval: "",
    subscriptionStartDate: "",
    subscriptionEndDate: "",
  });
  //location code reducer
  const { data: locationCodes = [] } = useSelector(
    (state) => state.LocationCodeListReducer
  );

  //Invoice form Reducer
  const {
    lineItems = [],
    subTotal = 0,
    discount = 0,
    tax = 0,
    grandTotalAmount = 0,
    taxPercentage = 0,
    discountPercentage = 0,
    invoiceExpiryDate = "",
    paymentExpiryDate = "",
    memo = "",
    couponId = 0,
    locationCode = "",
    subscriptionId: subId = 0,
  } = useSelector((state) => state.InvoiceFormReducer);

  const { detail: couponDetails = {}, error: couponError = false } =
    useSelector((state) => state.CouponDetailReducer);

  const subscriptionToogle = () => {
    setSubscriptionModal(!subscriptionModal);
  };

  //save Subscription Values
  const saveSubcriptionValues = (values) => {
    setSubscriptionInitialValues({
      invoiceSendInterval: values.invoiceSendInterval,
      subscriptionStartDate: values.subscriptionStartDate,
      subscriptionEndDate: values.subscriptionEndDate,
    });
    setSubscriptionModal(!subscriptionModal);
  };

  //Reset Subscription
  const resetFun = () => {
    setSubscriptionInitialValues({
      invoiceSendInterval: "",
      subscriptionStartDate: "",
      subscriptionEndDate: "",
    });
    setSubscriptionModal(!subscriptionModal);
  };

  //Preview Toggle
  const toggle = () => {
    setModal(!modal);
  };

  //Coupon Toggle
  const couponToggle = () => {
    setCouponModal(!couponModal);
  };

  //back
  const back = () => {
    history.push(AGENCY_INVOICE_PAGE);
  };

  //Handle Customer Modal Toggle
  const handleCustomerModalToggle = () => {
    setCustomerModalFlag(!customerModalFlag);
  };

  //Select Customer First
  const selectCustomer = (event) => {
    const { detail } = event.currentTarget.dataset;
    const parsedData = JSON.parse(detail || "{}");
    setCustomerSelected(parsedData);
    handleCustomerModalToggle();
  };

  //Add Invoice Line Item
  const addLineItem = () => {
    dispatch({
      type: INVOICE_ADD_LINE_ITEM,
    });
  };

  //remove Invoice Line Items
  const removeLineItem = (event) => {
    const { unique_id } = event.currentTarget.dataset;
    dispatch({
      type: INVOICE_DELETE_LINE_ITEM,
      payload: unique_id,
    });
  };

  //Field Value Change
  const fieldValueChange = (event, uniqueId, field) => {
    const { value = "" } = event.target;
    dispatch({
      type: INVOICE_LINE_ITEM_VALUES,
      uniqueId,
      field,
      payload: value,
    });
  };

  //taxAmount
  const handleAddTagToggle = () => {
    setShowTaxInput(true);
  };

  //add Subscriptions
  const addSubscriptions = () => {
    setSubscriptionModal(!subscriptionModal);
  };

  //Callback From Coupon Apply
  const callBackFromCouponApply = (data) => {
    setCouponModal(!couponModal);
    setCoupons({ ...data });
    dispatch({
      type: INVOICE_UPDATE_FORM_BASE_VALUES,
      field: "discountPercentage",
      payload: parseFloat(data.discountPercentage),
    });
  };

  //create Invoice API
  const createInvoice = async (value) => {
    const invoice_master_id = urlPaths[3];

    if (parseFloat(grandTotalAmount) > 0) {
      if (value == "Draft") {
        setLoading(true);
      } else {
        setLoader(true);
      }
      try {
        const options = {
          method: invoice_master_id ? "PUT" : "POST",
          url: invoice_master_id ? UPDATE_INVOICE_URL : CREATE_INVOICE_URL,
          headers: authHeader(),
          data: {
            invoiceMasterId: invoice_master_id ? invoice_master_id : undefined,
            createdBy: getCurrentUserId(),
            invoiceNumber: Date.now(),
            customerId: selectedCustomer.customerId,
            invoiceCurrency: "USD",
            invoiceStatus: value,
            invoiceExpiryDate:
              moment(invoiceExpiryDate).format("YYYY-MM-DD") == "Invalid date"
                ? moment(Date.now()).format("YYYY-MM-DD")
                : moment(invoiceExpiryDate).format("YYYY-MM-DD"),
            agencyId: getCurrentAgencyId(),
            taxPercentage: taxPercentage || 0,
            couponDiscountPercentage: discountPercentage || 0,
            actualInvoiceAmount: subTotal || 0,
            paymentAmount: parseFloat(grandTotalAmount) || 0,
            couponId: coupon ? coupon.couponId : null,
            memo: memo || "",
            paymentLinkExpiryDay: parseInt(paymentExpiryDate) || 0,
            locationCode: locationCode,
          },
        };
        const response = await API(options);
        const { status, message, invoiceMasterId } = response.data;
        if (status === "Success") {
          Swal.fire(getAlertToast("success", message));
          //subcription will Added Here
          let hasSubcription = Object.values(
            subscriptionInitialValues
          ).includes("");
          //  && value == 'Open'
          if (!hasSubcription) {
            subscriptionInitialValues.invoiceMasterId = invoiceMasterId;
            await createSubcription(subscriptionInitialValues, subId);
          }
          // if (parseFloat(grandTotalAmount) > 0) {
          saveInvoiceItems(value, invoiceMasterId);
          // }
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          Swal.fire(getAlertToast("error", data.message));
        }
      } finally {
        if (value == "Draft") {
          setLoading(false);
        } else {
          setLoader(false);
        }
      }
    } else {
      Swal.fire(getAlertToast("error", "Please add invoice item"));
    }
  };

  //saveInvoiceItems
  const saveInvoiceItems = async (value, id) => {
    setPageLoading(true);
    try {
      const options = {
        method: "POST",
        url: SAVE_INVOICE_URl,
        headers: authHeader(),
        data: {
          invoiceMasterId: id,
          customerId: selectedCustomer.customerId,
          agencyId: getCurrentAgencyId(),
          taxPercentage: taxPercentage || 0,
          couponDiscountPercentage: discountPercentage || 0,
          couponId: coupon ? coupon.couponId : null,
          memo: memo || "",
          paymentLinkExpiryDay: parseInt(paymentExpiryDate) || 0,
          actualInvoiceAmount: subTotal || 0,
          paymentAmount: parseFloat(grandTotalAmount) || 0,
          email: selectedCustomer.email || "",
          invoiceStatus: value,
          taxAmount: tax || 0,
          discountAmount: parseFloat(discount) || 0,
          invoiceItems: lineItems || [],
        },
      };
      const response = await API(options);
      const { status, message } = response.data;
      if (status === "Success") {
        Swal.fire(getAlertToast("success", message));
        history.push(AGENCY_INVOICE_PAGE);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setPageLoading(false);
    }
  };

  //create Subcription
  const createSubcription = async (values) => {
    const invoice_master_id = urlPaths[3];
    values.customerId = selectedCustomer.customerId;
    values.createdBy = getCurrentUserId();
    values.subscriptionStartDate = moment(values.subscriptionStartDate).format(
      "YYYY-MM-DD"
    );
    values.subscriptionEndDate = moment(values.subscriptionEndDate).format(
      "YYYY-MM-DD"
    );
    try {
      const options = {
        method: subscriptionId ? "PUT" : "POST",
        url: subscriptionId ? UPDATE_SUBSCRIPTION_URL : CREATE_SUBSCRIPTION_URL,
        headers: authHeader(),
        data: subscriptionId
          ? {
              subscriptionId: subscriptionId,
              invoiceMasterId: invoice_master_id,
              customerId: selectedCustomer.customerId,
              invoiceSendInterval: values.invoiceSendInterval,
              subscriptionStartDate: moment(
                values.subscriptionStartDate
              ).format("YYYY-MM-DD"),
              subscriptionEndDate: moment(values.subscriptionEndDate).format(
                "YYYY-MM-DD"
              ),
            }
          : values,
      };
      const response = await API(options);
      // console.log('Response ', response);
      const { status, message } = response.data;
      if (status === "Success") {
        Swal.fire(getAlertToast("success", message));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
    }
  };

  //Handle Form Base Value
  const handleChangeFormBaseValue = (event) => {
    const { name, value } = event.target;
    // console.log('tax', name, value);

    dispatch({
      type: INVOICE_UPDATE_FORM_BASE_VALUES,
      field: name,
      payload: value,
    });
  };

  const dateChange = (date) => {
    dispatch({
      type: INVOICE_UPDATE_FORM_BASE_VALUES,
      field: "invoiceExpiryDate",
      payload: date || 0,
    });
  };

  //selectSubcription
  const selectSubscription = async (subscriptionId) => {
    try {
      const options = {
        method: "GET",
        url: SELECT_SUBSCRIPTION_URL,
        headers: authHeader(),
        params: { subscriptionId: parseInt(subscriptionId) },
      };
      const response = await API(options);

      const { status, data } = response.data;
      // console.log('Data ', data);
      if (status === "Success") {
        setSubscriptionInitialValues({
          invoiceSendInterval: data.invoiceSendInterval,
          subscriptionStartDate: new Date(data.subscriptionStartDate),
          subscriptionEndDate: new Date(data.subscriptionEndDate),
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
    }
  };

  const removeCoupon = async (id) => {
    Swal.fire(getAlertToast("error", "Please Wait..."));
    try {
      const options = {
        method: "DELETE",
        url: REMOVE_COUPON_URL,
        headers: authHeader(),
        params: { couponId: parseInt(id) },
      };
      const response = await API(options);

      const { status, message } = response.data;
      // console.log('Data ', data);
      if (status === "Success") {
        Swal.fire(getAlertToast("error", message));
        setCoupons(null);
        dispatch({
          type: INVOICE_UPDATE_FORM_BASE_VALUES,
          field: "discountPercentage",
          payload: parseFloat(0),
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
    }
  };

  //Draft Invoice
  const handleDraftInvoice = async (invoice_master_id) => {
    setIntialLoader(true);
    const apiOption = {
      method: "GET",
      url: SELECT_INVOICE_URL,
      headers: authHeader(),
      params: { invoiceMasterId: invoice_master_id },
    };
    try {
      const response = await API(apiOption);
      const { status, data } = response.data;
      // console.log('response', status, data);

      if (status == "Success") {
        const {
          customerId = 0,
          customerName = "",
          email = "",
          subscriptionId = 0,
        } = data;
        setCustomerSelected({
          customerId: customerId,
          customerName: customerName,
          email: email,
        });
        setSubscriptionId(subscriptionId);
        dispatch({
          type: SAVE_INVOICE_FORM_REDUCER,
          payload: data,
        });
        setShowTaxInput(!showTaxInput);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
        history.push(AGENCY_INVOICE_PAGE);
      }
    } finally {
      setIntialLoader(false);
    }
  };

  const saveInvoiceFunction = () => {
    if (!locationCode) {
      Swal.fire(getAlertToast("error", "Please select location code"));
    } else {
      // setLoader(true);
      createInvoice("Draft");
    }
  };

  //send Invoice
  const handleSubmit = async (e) => {
    e.preventDefault();
    Swal.fire(getConfirm("warning", "Do you want to send the invoice?")).then(
      (result) => {
        if (result.value) {
          createInvoice("Open");
        }
      }
    );
  };

  const removeCouponFunction = (id) => {
    removeCoupon(id);
  };

  //Mount
  useEffect(() => {
    dispatch(
      getLocationCodeList({
        agencyId: getCurrentAgencyId(),
      })
    );
    console.log("location code", locationCodes);
    const invoice_master_id = urlPaths[3];
    if (invoice_master_id) {
      //Draft Invoice
      handleDraftInvoice(invoice_master_id);
    } else {
      dispatch({
        type: RESET_INVOICE_FORM_REDUCER,
      });
    }
  }, []);

  //Getting Coupon Info
  useEffect(() => {
    if (couponId) {
      dispatch(getCouponDetails(couponId));
    }
  }, [couponId]);

  //Getting Subcription Info
  useEffect(() => {
    if (subscriptionId) {
      selectSubscription(subscriptionId);
    }
  }, [subscriptionId]);

  useEffect(() => {
    //setting API values to state Coupon Flow
    if (
      Object.entries(couponDetails).length !== 0 &&
      couponDetails.constructor === Object
    ) {
      if (couponError) {
        Swal.fire(getAlertToast("error", couponDetails));
      } else {
        setCoupons({
          couponId: couponDetails.couponId,
          couponCode: couponDetails.couponCode,
          discountPercentage: couponDetails.discountPercentage,
        });
      }
    }
  }, [couponDetails]);
  return (
    <Fragment>
      {pageLoading && <CustomPageLoading />}

      <Container fluid className="mt-5">
        {/* Modal Search Customer */}
        {customerModalFlag && (
          <CustomModalSearch
            toggle={handleCustomerModalToggle}
            modal={customerModalFlag}
            selectCallBack={selectCustomer}
          />
        )}
        {/* Modal Search Customer */}

        {/* Modal Subscription */}
        {subscriptionModal && (
          <SubscriptionModal
            initialValues={subscriptionInitialValues}
            editFlow="edit"
            formCallback={saveSubcriptionValues}
            reset={true}
            resetFun={resetFun}
            modalFlag={subscriptionModal}
            toggleFunc={subscriptionToogle}
          />
        )}
        {/* Modal Subscription */}

        {/* Modal Coupon */}
        <ApplyCouponModal
          modalFlag={couponModal}
          modalToggle={couponToggle}
          callBack={callBackFromCouponApply}
        />
        {/* Modal Coupon */}

        {/* Preview ModaL */}
        <InvoicePreview
          toggle={toggle}
          modal={modal}
          selectedCustomer={selectedCustomer}
        />

        <br />
        <Card body>
          <CardTitle tag="h5">Create an invoice</CardTitle>
          <small>
            To send recurring invoices, create a subscription with a product and
            plan
          </small>
          <Row>
            {initialLoader ? (
              <Loader />
            ) : selectedCustomer ? (
              <>
                <Col md="6">
                  <div className={"select-customer-after"}>
                    <h6>Customer</h6>
                    <div className="box">
                      <div className="name">
                        <UserIcon />
                        <div
                          key={
                            selectedCustomer ? selectedCustomer.customerId : 0
                          }
                        >
                          <p>
                            {selectedCustomer ? selectedCustomer.email : "-"}
                          </p>
                          <small>
                            {selectedCustomer
                              ? selectedCustomer.customerName
                              : "-"}
                          </small>
                        </div>
                        <div className="btn-sec">
                          <Button
                            color="primary"
                            onClick={handleCustomerModalToggle}
                          >
                            Change Customer
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md="6">
                  <div className={"select-customer-after"}>
                    <h6>Subscription</h6>
                    <div className="box">
                      <div className="name">
                        <UserIcon />
                        <div>
                          <p>
                            {subscriptionInitialValues.subscriptionStartDate
                              ? `Start Date : ${moment(
                                  subscriptionInitialValues.subscriptionStartDate
                                ).format("MM/DD/YYYY")}`
                              : ""}
                          </p>
                          <p>
                            {subscriptionInitialValues.subscriptionEndDate
                              ? `End Date : ${moment(
                                  subscriptionInitialValues.subscriptionEndDate
                                ).format("MM/DD/YYYY")}`
                              : ""}
                          </p>
                          <p>
                            {subscriptionInitialValues.invoiceSendInterval
                              ? `Invoice Interval (in Days) : ${subscriptionInitialValues.invoiceSendInterval}`
                              : ""}
                          </p>
                        </div>
                        <div className="btn-sec">
                          <Button color="primary" onClick={addSubscriptions}>
                            {subscriptionInitialValues.subscriptionStartDate
                              ? "Edit Subscription"
                              : "Add Subscription"}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </>
            ) : (
              <Col md="12">
                <div className={"select-customer"}>
                  <h6>Customer</h6>
                  <div className="box">
                    <UserIcon />
                    <h6>Select a customer to begin creating an invoice.</h6>
                    <Button color="primary" onClick={handleCustomerModalToggle}>
                      Select a customer
                    </Button>
                  </div>
                </div>
              </Col>
            )}
          </Row>

          {selectedCustomer && (
            <Form onSubmit={handleSubmit}>
              <>
                <Row style={{ marginTop: "1rem" }}>
                  <Col md="6">
                    <FormGroup>
                      <Label htmlFor="memo">Memo</Label>
                      <Input
                        type="textarea"
                        rows="4"
                        id="memo"
                        name="memo"
                        value={memo}
                        onChange={handleChangeFormBaseValue}
                        placeholder="Enter memo"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label for="location code">
                        Location Code <span className="required-labels">*</span>
                      </Label>
                      <Input
                        type="select"
                        name="locationCode"
                        required
                        id="locationCode"
                        onChange={handleChangeFormBaseValue}
                        value={locationCode}
                      >
                        <option value="">
                          ------ Select Location Code -------
                        </option>
                        {locationCodes &&
                          locationCodes.map((record, index) => {
                            const { locationCode, description } = record;
                            return (
                              <option
                                value={locationCode}
                                key={`list_${index}`}
                              >
                                {locationCode + " " + (description || "N/A")}
                              </option>
                            );
                          })}
                      </Input>
                      {/* <FormFeedback>
                        {errors.locationCodeId && touched.locationCodeId
                          ? errors.locationCodeId
                          : ""}
                      </FormFeedback> */}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label htmlFor="invoiceExpiryDate">
                        Invoice Due Date
                      </Label>
                      <br />
                      <DatePicker
                        name="invoiceExpiryDate"
                        className={"form-control"}
                        style={{
                          zIndex: "9999 !important",
                          width: "100% !important",
                        }}
                        selected={invoiceExpiryDate}
                        onChange={dateChange}
                        minDate={Date.now()}
                        placeholderText="Invoice Expiry Date"
                        width="100%"
                        popperPlacement="bottom"
                        popperModifiers={{
                          flip: {
                            behavior: ["bottom"],
                          },
                          preventOverflow: {
                            enabled: false,
                          },
                          hide: {
                            enabled: false,
                          },
                        }}
                        required
                      />
                      {/* <Input
                        type="date"
                        id="invoiceExpiryDate"
                        name="invoiceExpiryDate"
                        value={invoiceExpiryDate}
                        onChange={handleChangeFormBaseValue}
                        placeholder="MM/DD/YYYY"
                        required
                      /> */}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label htmlFor="paymentExpiryDate">
                        Payment Link Expiry (in Days)
                      </Label>
                      <Input
                        type="number"
                        name="paymentExpiryDate"
                        value={paymentExpiryDate}
                        onChange={handleChangeFormBaseValue}
                        placeholder="Enter Payment Link Expiry (in Days)"
                        min={1}
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <hr />
                {/* Line Items */}
                <h6>Invoice items</h6>
                <Row>
                  <Col md="6">
                    <Label>Description</Label>
                  </Col>
                  <Col md="2">
                    <Label>Unit</Label>
                  </Col>
                  <Col md="2">
                    <Label>Price</Label>
                  </Col>
                </Row>
                {lineItems.map((record) => {
                  const {
                    uniqueId = 0,
                    itemDescription = "",
                    quantity = 0,
                    individualAmount = "",
                    totalAmount = "",
                  } = record;
                  return (
                    <Row className="mb-2" key={`line_item_${uniqueId}`}>
                      <Col md="6" className="d-flex item-center">
                        {lineItems.length > 1 && (
                          <div
                            data-unique_id={uniqueId}
                            onClick={removeLineItem}
                            style={{ cursor: "pointer", marginRight: "5px" }}
                          >
                            <i className="fas fa-minus-circle"></i>
                          </div>
                        )}

                        <Input
                          type="text"
                          name={`desc_${uniqueId}`}
                          id={`desc_${uniqueId}`}
                          placeholder="Enter Description"
                          value={itemDescription}
                          onChange={(event) =>
                            fieldValueChange(event, uniqueId, "itemDescription")
                          }
                          min={1}
                          required
                        />
                      </Col>
                      <Col md="2">
                        <Input
                          type="number"
                          name={`quant_${uniqueId}`}
                          id={`quant_${uniqueId}`}
                          placeholder="Enter Qty"
                          onChange={(event) =>
                            fieldValueChange(event, uniqueId, "quantity")
                          }
                          value={quantity}
                          min={1}
                          required
                        />
                      </Col>
                      <Col md="2">
                        <Input
                          type="number"
                          name={`unit_${uniqueId}`}
                          id={`unit_${uniqueId}`}
                          placeholder="Enter Unit Price"
                          onChange={(event) =>
                            fieldValueChange(
                              event,
                              uniqueId,
                              "individualAmount"
                            )
                          }
                          value={individualAmount}
                          min={0.01}
                          step="any"
                          required
                        />
                      </Col>
                      <Col md="2">
                        <div className="border-none text-right">
                          {amountFormat(totalAmount)}
                        </div>
                      </Col>
                    </Row>
                  );
                })}

                <Row>
                  <Col md="6">
                    <Button color="link" onClick={addLineItem}>
                      Add another
                    </Button>
                  </Col>
                  <Col md="6">
                    <div className="price-list">
                      <div className="list">
                        <Label for="" className="">
                          Amount
                        </Label>
                        <h6>{amountFormat(subTotal)} </h6>
                      </div>

                      <div className="list">
                        <Label for="" className="">
                          Tax
                        </Label>
                        {!showTaxInput ? (
                          <Button
                            color="link"
                            className="border-none"
                            onClick={handleAddTagToggle}
                          >
                            <AddButton />
                            Add Tax (%)
                          </Button>
                        ) : (
                          <Input
                            type="number"
                            name="taxPercentage"
                            value={taxPercentage}
                            onChange={handleChangeFormBaseValue}
                            placeholder="Tax Percentage"
                            style={{ width: "11rem" }}
                            min={0.1}
                            step="any"
                            max={100}
                          />
                        )}
                        <h6>{amountFormat(tax)}</h6>
                      </div>

                      {/* Coupons */}
                      <div className="list">
                        <Label for="" className="">
                          Discount
                        </Label>
                        {coupon ? (
                          <>
                            <Alert
                              color="success"
                              style={{
                                padding: "2px 10px 2px 7px",
                                marginTop: "0.5rem",
                              }}
                            >
                              <i class="fa fa-gift" aria-hidden="true"></i>
                              <span
                                style={{ fontSize: "12px", marginLeft: "4px" }}
                              >
                                Coupon Applied
                              </span>{" "}
                              <br />
                              <span
                                style={{ fontSize: "13px", fontWeight: 700 }}
                              >
                                {coupon.couponCode} -{" "}
                                {coupon.discountPercentage}%
                              </span>
                            </Alert>
                            <Button
                              color="link"
                              className="border-none"
                              onClick={() =>
                                removeCouponFunction(coupon.couponId)
                              }
                            >
                              <Remove />
                              Remove
                            </Button>
                          </>
                        ) : (
                          <Button
                            color="link"
                            className="border-none"
                            onClick={couponToggle}
                          >
                            <AddButton />
                            Add coupon
                          </Button>
                        )}
                        <h6> {amountFormat(discount)}</h6>
                      </div>

                      <hr />

                      <div className="list">
                        <Label for="" className="">
                          Total
                        </Label>
                        <h6>{amountFormat(grandTotalAmount)}</h6>
                      </div>
                    </div>
                  </Col>
                </Row>

                <hr />

                <CardFooter className="d-flex bg-white">
                  {selectedCustomer ? (
                    <div className="ml-auto">
                      <Button color="secondary" onClick={back}>
                        Back
                      </Button>
                      <Button color="success" onClick={saveInvoiceFunction}>
                        {loader && <CustomLoader loading={loading} />}
                        Save
                      </Button>
                      <Button color="info" onClick={toggle}>
                        Preview
                      </Button>
                      <Button color="primary" type="submit">
                        {loader && <CustomLoader loading={loading} />}
                        Send invoice
                      </Button>
                    </div>
                  ) : (
                    <div className="ml-auto">
                      <Button color="primary">Next</Button>
                    </div>
                  )}
                </CardFooter>
              </>
            </Form>
          )}
        </Card>
      </Container>
    </Fragment>
  );
}
